<template>
    <MasterTemplate 
        title="ผู้ใช้งานแต่ละสาขา" 
        itemKey="branchCode"
        :headers="headers" 
        :setData="setData"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        :onOpenDialog="onOpenDialog"
        >
        <template v-slot:formInput="{editedIndex, rules}">
            <v-row v-if="editedIndex == -1">
                <v-col cols="6" >
                    <v-autocomplete
                        v-model="editedItem.branchCode"
                        label="สาขา"
                        :items="branchs"
                        item-text="branchName"
                        item-value="branchCode"
                        :rules="[rules.required]"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-card
                    class="mx-auto ml-1"
                    max-width="300"
                    tile>
                        <v-list dense>
                            <v-subheader >
                                เพิ่มผู้ใช้งาน
                                <v-spacer></v-spacer>
                                <v-icon class="pr-2" small @click="userDialog = true">add</v-icon>
                            </v-subheader>
                            <v-divider></v-divider>
                            <v-list-item-group
                                v-model="selectedUser"
                                color="primary"
                            >
                                <v-list-item 
                                v-for="(item) in usernames"
                                :key="item"
                                :value="item">
                                    <v-list-item-icon>
                                        <v-icon>person</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item "></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                    
                        </v-list>
                    </v-card>
                </v-col>

                <v-col cols="6">
                    <v-card
                    class="mx-auto ml-1"
                    max-width="300"
                    tile>
                    
                        <v-list  dense>
                            <v-subheader>
                                หน้าจอ ({{groupCount}})
                            </v-subheader>
                            <v-divider></v-divider>
                            <v-list-item-group
                                v-model="selectedGroups"
                                color="primary"
                                multiple
                            >
                                <v-list-item 
                                v-for="(item, i) in userGroups"
                                :key="i">
                                <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.groupName"></v-list-item-title>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-checkbox
                                        :input-value="active"
                                        color="deep-purple accent-4"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                    </template>

                                </v-list-item>
                            </v-list-item-group>
                    
                        </v-list>
                    </v-card>
                </v-col>
                <v-dialog v-model="userDialog">
                    <v-card
                    class="mx-auto"
                    max-width="500"
                    max-height="500">
                        <v-card-title>ชื่อผู้ใช้งาน</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        v-model="editedItem.usernames"
                                        :items="allUser"
                                        chips
                                        ref="cboUser"
                                        small-chips
                                        style="max-height:500!important"
                                        :menu-props="{'maxHeight':'500!important',auto:true}"
                                        label="ชื่อผู้ใช้งาน"
                                        multiple
                                        aria-checked=""
                                        :rules="[rules.required]"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="userDialog = false">ตกลง</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row v-for="user in editedItem.usernames" :key="user">
            </v-row>
        </template>
    </MasterTemplate>
</template>
<style scoped>
    .v-list {
        height: 300px;
        overflow: auto;
    }

</style>
<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {getUserBranch, isExist, listUserBranch, listAvaliableBranch, listUserByBranch, insert, update, deleteUserBranch} from '@/api/user-branch-api.js'
import {list} from '@/api/master/user-api.js'
import {listGroup} from '@/api/master/group-api.js'

export default {
    name: 'Branch',
    components: {
        MasterTemplate
    },
     computed: {
        groupCount() {
            return this.selectedGroups.length;
        },
        allUser() {
            return this.users;
        },
        usernames() {
            return this.editedItem.usernames;
        },
        userGroups() {
            if (this.selectedUser)  {
                return this.groups;
            }
        }
    },
     watch: {
         userDialog(val) {
             if (!val && this.editedItem.usernames.length > 0) {
                 this.selectedUser = this.editedItem.usernames[this.editedItem.usernames.length - 1];
             }
         },
         selectedGroups(val) {
             let user = this.userPemissions.filter(o => o.username == this.selectedUser);
             if (user.length <= 0) {
                 return;
             }
             user[0].groups = val;
             /*
             user[0].groupsCode = [];
             val.forEach(i => {
                 user[0].groupsCode.push(this.groups[i].groupCode);
             });
             */
             let index = this.userPemissions.indexOf(user[0]);
             if (index >= 0) {
                 this.userPemissions[index] = user[0];
                 this.userPemissions[index].isEdited = true;
             }
         },
         selectedUser(val) {
             if (val) {
                 let user = this.userPemissions.filter(o => o.username == val);
                 if (user.length <= 0) {
                     this.userPemissions.push({
                         username: val,
                         groups: [],
                         groupsCode: []
                     })
                     this.selectedGroups = [];
                 } else {
                     this.selectedGroups = user[0].groups;
                 }
             }
         }
    },
    data: () => ({
        selectedGroups: [],
        selectedUser: '',
        userPemissions: [
            {
                username: '',
                groups: [],
                groupsCode: [],
                isEdited: false
            }
        ],
        userDialog: false,
        isDup: false,
        isEdit: false,
        headers: [
            {text: 'รหัสสาขา', value: 'branchCode'},
            {text: 'ชื่อสาขา', value: 'branchName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        branchs: [],
        groups: [],
        users: [],
        editedItem: {
            userBranchId: '-1',
            branchCode: '',
            groupCode: '',
            usernames: [],
            userPemissions: []
        },
        defaultItem: {
            userBranchId: '-1',
            branchCode: '',
            groupCode: '',
            usernames: [],
            userPemissions: []
        },
    }),
    methods: {
        listData() {
            return listUserBranch();
        },
        deleteData(item) {
            return deleteUserBranch(item.branchCode);
        },
        insertData() {
            this.setPermission()
            return insert(this.editedItem);
        },
        setPermission() {
            let perm = [];
            this.editedItem.usernames.forEach(e => {
                let userPerm = this.userPemissions.filter(o => o.username == e)[0];
                userPerm.groupsCode = [];
                userPerm.groups.forEach(i => {
                    userPerm.groupsCode.push(this.groups[i].groupCode);
                });
                perm.push(userPerm);
            });
            this.editedItem.userPemissions = perm;
        },
        updateData() {
            this.setPermission();
            console.log(this.editedItem);
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.branchName;
        },
        setData(item, isEdit) {
            this.editedItem = item;
            this.editedItem.usernames = [];
            this.isEdit = isEdit;
        },
        loadUserPerm() {
            let _this = this;
            if (this.editedItem.branchCode) {
                getUserBranch(this.editedItem.branchCode).then(rs => {
                    rs.forEach((v, i) => {
                        let tmpGroups = [];
                        v.groupsCode.forEach(o => {
                            let obj =  _this.groups.filter(g => g.groupCode == o);
                            if (obj.length > 0) {
                                let idx = _this.groups.indexOf(obj[0]);
                                tmpGroups.push(idx);
                            }
                        });
                        _this.editedItem.usernames.push(v.username);
                        _this.userPemissions.push({
                            username: v.username,
                            groupsCode: v.groupCode,
                            groups: tmpGroups
                        });
                        if (_this.userPemissions.length > 0) {
                            this.selectedUser = _this.userPemissions[0].username;
                        }
                        
                    });
                });
            }
        },
        onOpenDialog() {
            this.selectedUser = '';
            this.selectedGroups = [];
            
            if (!this.isEdit) {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
            
            this.userPemissions = [];

            listAvaliableBranch().then(rs => {
                this.branchs = rs;
            });

            // list user
            list().then(rs => {
                //console.log(rs);
                rs.forEach((v, i) => {
                    this.users.push(v.username);
                });
            });

            listGroup().then(rs => {
                this.groups = rs;
            }).then( rs => {
                this.loadUserPerm();
            });
        }
    }

}
</script>